import { FieldConfig } from "../../../SetupFormGenerator/types";
import {
  DEFAULT_FORM_OF_INCOME_FIELD,
  DEFAULT_INTERNAL_NOTES_FIELD,
  DEFAULT_MARK_RECURRING_PAYMENT_FIELD,
  DEFAULT_PAY_PERIOD_FIELD,
  DEFAULT_RECURRING_CADENCE_FIELD,
} from "../DEFAULT/constants";
import { COMPONENTLIST } from "../../../SetupFormGenerator/constants";

export enum TaxableBenefits {
  CAR = "Car",
  COMMUTER_ALLOWANCE = "Commuter allowance",
  EDUCATION = "Education",
  LIVING_ACCOMMODATIONS = "Living accommodations",
  LOANS = "Loans",
  MEAL_ALLOWANCE = "Meal allowance",
  MEDICAL_INSURANCE = "Medical insurance",
  MOVING = "Moving",
  NON_CASH_GIFTS_AND_AWARDS = "Non-cash gifts & awards",
  PHONE_AND_INTERNET = "Phone & internet",
  RECREATIONAL_FACILITIES_AND_DUES = "Recreational facilities & dues",
  REMOTE_WORK = "Remote work",
}

export const TAXABLEBENFITSVALUES = Object.values(TaxableBenefits);

export const TaxableBenefitsTypeMessage = null;

export const FI_CAR_BENEFIT_TYPE_FIELD: FieldConfig = {
  label: "Car Benefit Type",
  name: "carBenefitType",
  type: COMPONENTLIST.RADIO,
  options: [
    {
      value: "unlimited",
      label: "Unlimited Benefit",
      description:
        "Employer covers all vehicle costs including fuel or charging.",
    },
    {
      value: "limited",
      label: "Limited Benefit",
      description:
        "Employee provides car but employee pays for fuel or charger costs.",
    },
  ],
  required: true,
  renderCheck: (data) => {
    const paymentSettings = data?.setUp?.payload?.paymentSettings;
    const benefitType =
      paymentSettings && "benefitType" in paymentSettings
        ? (paymentSettings as { benefitType?: string }).benefitType ?? ""
        : "";
    return benefitType === TaxableBenefits.CAR;
  },
};

export const PAYMENT_SETTINGS_FIELDS: FieldConfig[] = [
  FI_CAR_BENEFIT_TYPE_FIELD,
  DEFAULT_FORM_OF_INCOME_FIELD,
  DEFAULT_PAY_PERIOD_FIELD,
  DEFAULT_MARK_RECURRING_PAYMENT_FIELD,
  DEFAULT_RECURRING_CADENCE_FIELD,
  DEFAULT_INTERNAL_NOTES_FIELD,
];
